import { useAppContext } from '../../context/AppContext.js';
import "./style.css";
import api from "../../services/api";
import React, { useState, useEffect } from 'react';
import FloatingMenu from "../../componente/menuflutuante/index.jsx"; // Componente do menu flutuante
import TopBar from "../../componente/topbar/index.jsx";
import PopUp from "../../componente/popup/index.jsx";

function Lojinha() {
    const [saldo, setSaldo] = useState(0); // Saldo inicial do colaborador
    const [listaItens, setListaItens] = useState([]);
    const [busca, setBusca] = useState("");
    const [quantidades, setQuantidades] = useState({}); // Estado para quantidade por produto

    const { codcolaborador, selectedCompany, codassinante, accessKey, nomeDoColaborador, fotoPerfil } = useAppContext(); // Acessa os dados do contexto

    const [isOpen, setIsOpen] = useState(false);
    const [item, setItem] = useState({}); // Estado para quantidade por produto

    const handleOpen = (aitem) => {
        setItem(aitem);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        handleComprar(item)
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    // Carrega o saldo e lista os itens na inicialização da página
    useEffect(() => {
        saldoCoin();
        listarItens();
    }, []);

    // Lista os itens da lojinha, filtrando pela busca
    useEffect(() => {
        listarItens();
    }, [busca]);

    function listarItens() {
        api
            .get("/v1/cadastro/lojinha", {
                params: {
                    busca: busca,
                    codempresa: selectedCompany,
                    codassinante,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then((response) => {
                setListaItens(response.data);
                const initialQuantities = response.data.reduce((acc, item) => {
                    acc[item.codproduto] = 1; // Define a quantidade inicial como 1
                    return acc;
                }, {});
                setQuantidades(initialQuantities);
            })
            .catch((err) => {
                console.error("Ocorreu um erro ao listar itens: " + err);
            });
    }

    function saldoCoin() {
        api
            .get("/v1/cadastro/colaborador/saldocoin", {
                params: {
                    codcolaborador,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then((response) => {
                setSaldo(response.data.saldocoin);
            })
            .catch((err) => {
                console.error("Ocorreu um erro ao buscar o saldo: " + err);
            });
    }

    function handleComprar(item) {
        const quantidade = quantidades[item.codproduto] || 1;
        const total = quantidade * item.valor;

        if (total > saldo) {
            alert("Saldo insuficiente para realizar a compra.");
            return;
        }

        if (quantidade > item.estoque) {
            alert("Quantidade solicitada excede o estoque disponível.");
            return;
        }

        // Registra a compra na API
        api
            .post(
                "/v1/cadastro/lojinha/comprar",
                {
                    codcolaborador,
                    codproduto: item.codproduto,
                    quantidade,
                    codempresa: selectedCompany,
                    codassinante,
                    valor: item.valor
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then((response) => {
                alert("Compra realizada com sucesso!");
                setSaldo((prevSaldo) => prevSaldo - total); // Atualiza o saldo localmente
                listarItens(); // Atualiza a lista de itens
            })
            .catch((err) => {
                console.error("Erro ao registrar compra: " + err);
                alert("Ocorreu um erro ao tentar registrar a compra.");
            });
    }

    function handleQuantidadeChange(codproduto, value) {
        setQuantidades((prev) => ({
            ...prev,
            [codproduto]: Math.max(1, parseInt(value) || 1), // Garante valor mínimo de 1
        }));
    }

    return (<>
        <TopBar nomeColaborador={nomeDoColaborador} foto={fotoPerfil} />
        <FloatingMenu />
        <div className="lojinha-container">
            <div>
                <PopUp isOpen={isOpen} onClose={handleClose}>
                    <h2>Verificação</h2>
                    <p>Tem certeza que deseja comprar esse produto?</p>

                    <div className="row">
                        <div className="col-12 mt-3 d-flex justify-content-end">
                            <button
                                className="btn btn-primary me-2"
                                onClick={handleConfirma}
                            >
                                Sim
                            </button>
                            <button className="btn btn-danger" onClick={handleClose}>
                                Não
                            </button>
                        </div>
                    </div>
                </PopUp>
            </div>

            <header className="lojinha-header">
                <h1 className="lojinha-titulo">Lojinha Virtual</h1>
                <div className="lojinha-saldo">
                    <span>Saldo: </span>
                    <strong>{saldo} Coins</strong>
                </div>
            </header>

            <div className="lojinha-busca">
                <input
                    type="text"
                    placeholder="Buscar produtos..."
                    value={busca}
                    onChange={(e) => setBusca(e.target.value)}
                />
                <button onClick={listarItens}>Buscar</button>
            </div>

            <div className="lojinha-produtos">
                {listaItens.map((item) => (
                    <div className="card-produto" key={item.codproduto}>
                        <img
                            src={item.foto || "https://via.placeholder.com/150"}
                            alt={item.descricao}
                            className="produto-foto"
                        />
                        <div className="produto-info">
                            <h5>{item.descricao}</h5>
                            <p>Ref: {item.referencia}</p>
                            <p>Preço: {item.valor} Coins</p>
                            <p>Disponível: {item.estoque}</p>
                            <div className="produto-compra">
                                <input
                                    type="number"
                                    min="1"
                                    value={quantidades[item.codproduto] || 1}
                                    onChange={(e) =>
                                        handleQuantidadeChange(
                                            item.codproduto,
                                            e.target.value
                                        )
                                    }
                                    className="produto-quantidade"
                                />
                                <button
                                    className="btn-comprar"
                                    onClick={() => handleOpen(item)}
                                >
                                    Comprar
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </>
    );
}

export default Lojinha;
